import m, {Vnode, VnodeDOM} from "mithril";
import h from "../../../../ui/design";
import Cell from "../../../../model/form/cell";
import {InputTextItem} from "../../../../model/items/inputText";
import {Questionary} from "../../../../model/questionary";
import {CellItem} from "../../../../model/items/cellItem";
import {RadioItem} from "../../../../model/items/radio";
import RadioCellInputTextItem from "./RadioCellInputTextItem";

export default class RadioCell {

    private readonly radio!: RadioItem;
    private readonly inputTextItem: InputTextItem|null = null;
    private readonly inputTextText: RadioCellInputTextItem|null = null;
    private readonly questionary: Questionary;

    constructor(
        public readonly cell: Cell,
        private readonly setValue: ((cellItem: CellItem, value: any)=>void)|null = null,
        private readonly onFinishInput: (()=>void)|null = null
    ) {
        this.questionary = cell.grid.questionary;

        for (const item of cell.cellItems) {
            if (item instanceof RadioItem) {
                this.radio = item;
            } else if (item instanceof InputTextItem) {
				this.inputTextItem = item;
                this.inputTextText = new RadioCellInputTextItem(this.radio, item, setValue, onFinishInput);
            }
        }

        if (!this.radio) {
            throw Error(`Expected radio in cell ${cell.id} missing.`);
        }
    }

    public view(): Vnode|null {

        if (!this.cell.visible) {
            return null;
        }

        const checked = this.radio.isChecked();

        const cssClass = 'radioCell'
            + (this.cell.cssClass ? (' '+this.cell.cssClass) : '')
            + (checked ? ' checked' : '') // this radio is checked
            + (!checked && this.radio.getVariable() ? ' unchecked' : '') // sibling radio is checked
        ;

        return m("div", {
            "class": cssClass
        }, [
            m("label", {}, [
                m("input", {
                    type: "radio",
                    id: this.radio.variableName +'_'+this.radio.getValue(),
                    name: this.radio.variableName,
                    value: this.radio.getValue(),
                    disabled: !this.cell.enabled,
                    tabindex: 1,
                    onclick: () => {
                        const value = this.radio.getValue();
                        if (this.setValue) {
                            this.setValue(this.radio, value);
                        } else {
                            this.radio.setVariable(value);
                        }
                        this.inputTextText?.focus();
                    },
                    checked: checked,
                }),
                m("span"+(this.cell.enabled ? (checked ? h.backgroundSecondary : '') : h.backgroundDisabled ), {},
                    m('.option-label', {}, m.trust(this.questionary.renderText(this.radio.childrenTags[0]?.value ?? '')) ),
                    this.inputTextText ? m(this.inputTextText) : null,
                )
            ])
        ]);
    }

    public oncreate(vnode: VnodeDOM): void {
        if (this.inputTextItem) {
            $(vnode.dom).find('input[type="text"]').val(this.inputTextItem.getVariable());
        }
    }

}